

export abstract class CdnSchemaJsonParsingResult<TEntity, TJsonParsingInputType> {

    public parsedEntities?: TEntity[];
    public inputType?: TJsonParsingInputType;

    constructor(public valid: boolean, public parsedValue: any, public errors: Array<string> = []) { }

}